import { withInstall } from "../utils/index.mjs";
import _SwipeItem from "./SwipeItem.mjs";
const SwipeItem = withInstall(_SwipeItem);
var stdin_default = SwipeItem;
export {
  SwipeItem,
  stdin_default as default
};
